import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import BSPagination from "../../Components/pagination";
import { useNavigate } from "react-router-dom";
import {
  fetchPaginatedReviews,
  searchReviewsByQuery,
  searchReviewsByStatus,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import ReviewEditModal from "./updateReviewModal";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
const GameReviewsList = ({
  gameReviews,
  setGameReviews,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [selectedReview, setSelectedReview] = useState({});
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [status, setStatus] = useState("");
  const [filtering, setFiltering] = useState(false);
  const tableRef = useRef(null);

  useEffect(() => {
    fetchReviews(pagination, query);
  }, [pagination.currentPage, pagination.pageSize]);

  // // // Fetch paginated list again
  const fetchReviews = async (pgntn, str = "") => {
    setFiltering(true);
    const res = await fetchPaginatedReviews(
      pgntn.currentPage,
      pgntn.pageSize,
      str
    );
    if (res?.data?.success && res?.data?.data) {
      setGameReviews(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Game Reviews list: ");
    setFiltering(false);
  };

  // // // Search
  const handleSearch = async (e) => {
    setFiltering(true);
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      const res = await searchReviewsByQuery(string);
      if (res?.data?.success && res?.data?.data) {
        setGameReviews(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate, "Search Reviews: ");
      }
    } else {
      await fetchReviews(pagination);
    }
    setFiltering(false);
  };

  // // // search by status
  const handleSearchByStatus = async (e) => {
    setFiltering(true);
    const string = e.target.value;
    setStatus(string);
    if (string.length > 0) {
      const res = await searchReviewsByStatus(string);
      if (res?.data?.success && res?.data?.data) {
        setGameReviews(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate, "Search Reviews: ");
      }
    } else {
      await fetchReviews(pagination);
    }
    setFiltering(false);
  };

  // // // Change page Logic
  const handlePageChange = async (page) => {
    setFiltering(true);
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    fetchReviews(temp);
    setFiltering(true);
  };

  // // // OpenEdit Modal
  const handleOpenEditModal = async (review) => {
    if (!granted?.some((perm) => perm?.type === "update")) {
      toast.error(
        "You don't have neccessary permissions to do this operation.",
        { duration: 3000 }
      );
      return;
    }
    setSelectedReview(review);
    setOpenDetailsModal(true);
  };

  // // // Reset all filters to default
  const resetFilters = async () => {
    setStatus("");
    setQuery("");
    await fetchReviews(pagination);
  };

  useEffect(() => {
    if (!tableRef.current) return;
    // only init when we actually have data
    const rows = gameReviews.map((r) => ({
      review: `<span style="display:block; max-width:250px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${r.review_text}</span>`,
      reviewer: r.reviewed_by?.email || "—",
      game: r.game_reviewed?.title || "—",
      status: `<span class="${
        r.status === "pending"
          ? "text-info"
          : r.status === "approved"
          ? "text-success"
          : "text-danger"
      }">${r.status}</span>`,
      action: `<button class="btn btn-sm btn-outline-primary edit-btn" data-id="${r.id}" title="update details">
                 <i class="fas fa-edit"></i>
               </button>`,
    }));

    const config = {
      data: rows,
      columns: [
        { title: "Review",   data: "review" },
        { title: "Reviewed by", data: "reviewer" },
        { title: "Game",     data: "game" },
        { title: "Status",   data: "status", orderable: false },
        { title: "Action",   data: "action", orderable: false, className: "text-center" },
      ],
      destroy:    true,
      responsive: true,
      paging:     false,
      searching:  false,
      info:       false,
      autoWidth:  false,
    };

    const $tbl = $(tableRef.current);
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $tbl.DataTable().clear().destroy();
      $tbl.find("tbody").empty();
    }
    $tbl.DataTable(config);

    // Delegate edit button clicks 
    $tbl
      .off("click", ".edit-btn")
      .on("click", ".edit-btn", (e) => {
        const id = $(e.currentTarget).data("id");
        const review = gameReviews.find((r) => r.id === id);
        handleOpenEditModal(review);
      });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $tbl.DataTable().destroy();
      }
    };
  }, [gameReviews, granted]);
  
  return (
    <div className="container py-4 text-light bg-dark p-3 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-8 row">
          <div className="col-md-4">
            <Form.Control
              type="text"
              placeholder="Search..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="form-control bg-dark text-light border-light input-placeholder-light"
              style={{ width: "45%" }}
            />
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <Form.Select
                type="text"
                placeholder="Search FAQs by category..."
                value={status}
                onChange={(e) => {
                  handleSearchByStatus(e);
                }}
                className="bg-dark text-light border-light input-placeholder-light"
              >
                <option value="">All</option>
                <option className="text-info" value="pending">
                  Pending
                </option>
                <option className="text-success" value="approved">
                  Approved
                </option>
                <option className="text-danger" value="rejected">
                  Rejected
                </option>
              </Form.Select>
            </div>
          </div>
          <div className="col-md-2">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <div className="row ">
                <Button
                  title="Reset Filters And Rrfresh Records"
                  className="btn btn-success"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="table-responsive">
        {/* DataTable */}
        <table
          ref={tableRef}
          className="table table-striped table-hover table-dark w-100"
        />
        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      {/* //////////////// Details And Update Modal //////////////// */}
      <ReviewEditModal
        selectedReview={selectedReview}
        setSelectedReview={setSelectedReview}
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
        fetchReviews={fetchReviews}
        pagination={pagination}
      />
    </div>
  );
};

export default GameReviewsList;